















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import CashFlowInitialVue from "../components/CashFlowStatement/CashFlowInitial.vue";
import { mapGetters } from "vuex";
@Component({})
export default class CashFlowInitial extends Vue {
    @Prop({ type: String })
    yearPeriod?: string;

    cashData: CashFlow.CashData[] = [];

    created() {
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .post(`cash/find`, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                let tempArr = res.data.cashList;
                tempArr.splice(tempArr.length - 3, 3);
                this.cashData = tempArr;
            });
    }
    // 进入焦点
    numDataFocus(el: any) {
        el.currentTarget.style.backgroundColor = "white";
        el.currentTarget.style.textAlign = "left";
        el.currentTarget.select();
    }

    // 失去焦点 保存
    numDataBlur(el: any, data: CashFlow.CashData) {
        el.currentTarget.style.backgroundColor = "";
        el.currentTarget.style.textAlign = "right";
        el.currentTarget.type = "text";
        Vue.axios
            .post(`cash/save`, {
                initbalance: Number(el.currentTarget.value.replace(/,/g, "")),
                id: data.id
            })
            .then(res => {
            });
    }

    // 快捷键 enter 事件
    toNext(el: any, name: number) {
        let inputs: any = document.querySelectorAll("#CashFlowInitial input");
        let trTags: any = document.querySelectorAll("#CashFlowInitial tr");
        for (var i = 0; i < trTags.length; i++) {
            trTags[i].setAttribute("class", "");
        }
        for (var i = 0; i < inputs.length; i++) {
            if (i == inputs.length - 1) {
                inputs[inputs.length - 1].blur();
            }
            if (inputs[i].getAttribute("name") > name) {
                trTags[inputs[i].getAttribute("name")].setAttribute(
                    "class",
                    "hover-lighter-main-background hover-lighter-background-table-input bgColor"
                );
                inputs[i].focus();
                return;
            }
        }
    }
    // 点击行的颜色
    addColor(event: any) {
        let trTags: any = document.querySelectorAll("#CashFlowInitial tr");
        for (var i = 0; i < trTags.length; i++) {
            trTags[i].setAttribute("class", "hover-lighter-main-background hover-lighter-background-table-input");
        }
        event.currentTarget.setAttribute("class", "hover-lighter-main-background hover-lighter-background-table-input bgColor");
    }
}
